import { render, staticRenderFns } from "./DropdownConfirmation.vue?vue&type=template&id=473f6576&scoped=true&"
import script from "./DropdownConfirmation.vue?vue&type=script&lang=js&"
export * from "./DropdownConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DropdownConfirmation.vue?vue&type=style&index=0&id=473f6576&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f6576",
  null
  
)

export default component.exports